import { isAdminOn } from "src/utils/hallinta/companyRoles";

// Global person = owned by no company. The hallinta person-list rows (proc
// asiakasPerson_getPersons) expose the owner as `person_ownerAsiakasId`, NOT
// `ownerAsiakasId`. The server (canSetPersonOwner) is the real gate; this only
// decides whether to render the "Tee globaaliksi" control.

/** True when the person row is global. */
export function isPersonGlobal(person) {
  return person == null || person.person_ownerAsiakasId == null;
}

/**
 * Visibility mirror of the server make-global gate: self → always; company-admin of
 * the owning company → release their own person → global. (Betonijerry does not
 * surface a system-admin flag; sysadmins use puminet4.)
 */
export function canMakePersonGlobal(user, person) {
  if (!user || !person) return false;
  if (isPersonGlobal(person)) return false;
  const selfPersonId = user?.person?.[0]?.personId;
  if (selfPersonId != null && Number(selfPersonId) === Number(person.personId)) return true;
  return isAdminOn(user, person.person_ownerAsiakasId);
}
